import styled from 'styled-components';

export default styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/subtitle.js